import styled from "styled-components";

// https://developer.mozilla.org/en-US/docs/Web/HTML/Element/header

export const Header = styled.header``;
